import React from "react";
import {
  Layout, Modal,
  Spin,
  Row,
  Col,
  Button, Form,
  message,
} from "antd";
import EditMember from "./EditMember";
import MiCompAPI from "../../../util/api";
import UserMember from "./UserMember";
import MemberForm from "./MemberForm";
import AddMember from "./AddMember";
const { Content } = Layout;
class MemberProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      currentTab: "general",
      personalDetailsEditable: false,
      addressDetailsEditable: false,
      memberEditable: false,
      addMemberActive: false,
      memberdata: null,
      memberaddress: null,

      states: [],
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount() {
    this.signUpForm = Form.create()(MemberForm);
    this.GetMemberProfilebyId();
    this.GetMasters();

  }
  addMemberDefaultHandler = () => {
    this.setState({ addMemberActive: !this.state.addMemberActive });
  };
  GetMemberProfilebyId = (state_updates = {}) => {
    this.setState({ isLoading: true });
    this.api.invoke(
      "GetMemberProfilebyId",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              ...state_updates,
              memberdata: data.data,
              memberaddress: data.data.memAddress,
              memberfamily: data.data.members,
              isLoading: false,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  };
  handleEditStatus = (type) => {
    ;
    if (type === "personal_details")
      this.setState({
        personalDetailsEditable: !this.state.personalDetailsEditable,
      });
    else if (type === "addesss_details")
      this.setState({
        addressDetailsEditable: !this.state.addressDetailsEditable,
      });
    else if (type === "member")
      this.setState({
        memberEditable: !this.state.memberEditable,
      });
  };
  handleEditSubmit = (data) => {
    this.api.invoke(
      "PersonalDetailsUpdate",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({
              personalDetailsEditable: !this.state.personalDetailsEditable,
            });
          } else {
            message.destroy();
            message.success(data.statusMessage, 3);
          }
        } else {
          message.destroy();
          message.error(
            "Failed to update Personal Details. Contact Support",
            2.5
          );
        }
      },
      data
    );
  };
  handleMemberAddressUpdateSubmit = (data) => {
    this.api.invoke(
      "MemberAddressUpdate",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({
              addressDetailsEditable: !this.state.addressDetailsEditable,
            });
            this.GetMemberProfilebyId();

          } else {
            message.destroy();
            message.success(data.statusMessage, 3);
          }
        } else {
          message.destroy();
          message.error(
            "Failed to update address Details. Contact Support",
            2.5
          );
        }
      },
      { id: this.state.memberdata.memAddress.id, ...data }
    );
  };
  removeMember = (Id) => {
    this.api.invoke(
      "DeleteFamilyMemberbyId/" + Id,
      "patch",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
          this.GetMemberProfilebyId();
        }
      }
    );
  }
  GetMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            states: data.states,

          });
        }
      },
      ["STATE"]
    );
  }

  handleClick = (e) => {
    this.setState({
      currentTab: e.key,
    });
  };
  addMemberDefaultHandler = () => {
    this.setState({ addMemberActive: !this.state.addMemberActive });
  };
  addMemberSubmitHandler = (data) => {
    data = {
      id: data.id,
      first_Name: data.first_Name,
      middle_Name: data.middle_Name,
      last_Name: data.last_Name,
      dateOfBirth: data.dateOfBirth,
      relation: data.relation,
      gender: data.gender,
    };
    message.loading("Adding Member..");
    this.api.invoke(
      "AddUpdateFamilyMember",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addMemberActive: false });
            this.GetMemberProfilebyId();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        } else {
          message.destroy();
          message.error("Add member failed. Contact Support", 3);
        }
      },
      data
    );
  };
  viewDocumentsHandler = () => { };
  getSelectedTabView() {
    if (this.state.isLoading) {
      return (
        <div className="mi_main" style={{ textAlign: 'center' }}>
          <Spin size="large" />
        </div>
      );
    }
    switch (this.state.currentTab) {
      case "general": {
        let personalDetailsCard, familyCard, addressDetailsCard;
        if (this.state.personalDetailsEditable) {
          personalDetailsCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={15}>
                  <p className='mi_title' style={{ color: '#fd828d' }}>Personal Details</p>
                </Col>
                <Col span={9}>
                  <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "personal_details")} > <i className="fa fa-times mi_icon mi_icon_red" ></i></Button>
                </Col>
              </Row>
            </div>
          );
        } else {
          personalDetailsCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={18}>
                  <p className='mi_title' style={{ color: '#fd828d' }}>Personal Details</p>
                </Col>
              </Row>
              <Row>
                <Col md={8} sm={24}>
                  <p className="mi_name">Name</p>
                  <p className="mi_value">{
                    this.state.memberdata.member.name ? this.state.memberdata.member.name : 'none'

                  }</p>
                </Col>
                <Col md={8} sm={24}>
                  <p className="mi_name">Email Address</p>
                  <p className="mi_value">{
                    this.state.memberdata.member.email ? this.state.memberdata.member.email : 'none'
                  }</p>
                </Col>
                <Col md={8} sm={24}>
                  <p className="mi_name">Mobile Number</p>
                  <p className="mi_value">{
                    this.state.memberdata.member.MobileNumber ? this.state.memberdata.member.MobileNumber : 'none'
                  }</p>
                </Col>

              </Row>
            </div>
          );
        }
        if (this.state.addressDetailsEditable) {
          addressDetailsCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={15}>
                  <p className='mi_title' style={{ color: '#fd828d' }}>Address Details</p>
                </Col>
                <Col span={9}>
                  <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "addesss_details")} > <i className="fa fa-times mi_icon mi_icon_red" ></i></Button>
                </Col>
              </Row>
              <this.signUpForm states={this.state.states} isexistprofile={true} data={this.state.memberdata.memAddress} id={this.state.memberdata.member.user_id} submitHandler={this.handleMemberAddressUpdateSubmit} />

            </div>
          );
        } else {
          addressDetailsCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={18}>
                  <p className='mi_title' style={{ color: '#fd828d' }}>Address Details</p>
                </Col>
                <Col span={6}>
                  <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "addesss_details")} > <i className="fa fa-pencil mi_icon" /></Button>

                </Col>
              </Row>
              <Row span={24}>
                <Col md={4} sm={24}>
                  <p className="mi_name">Street</p>
                  <p className="mi_value">{this.state.memberaddress.street ? this.state.memberaddress.street : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">Street 1</p>
                  <p className="mi_value">{this.state.memberaddress.street1 ? this.state.memberaddress.street1 : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">City</p>
                  <p className="mi_value">{this.state.memberaddress.city ? this.state.memberaddress.city : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">State</p>
                  <p className="mi_value">{this.state.memberaddress.state ? this.state.memberaddress.state : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">Zip Code</p>
                  <p className="mi_value">{this.state.memberaddress.zipCode ? this.state.memberaddress.zipCode : 'none'}</p>
                </Col>
              </Row>
            </div>
          );
        }
        if (this.state.memberEditable) {
          familyCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={15}>
                  <p className='mi_title' style={{ color: '#fd828d' }}>Family</p>
                </Col>
                <Col span={9}>
                  <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "member")}   > {this.state.memberEditable ?
                    <i className="fa fa-times mi_icon mi_icon_red" />
                    :
                    <i className="fa fa-pencil mi_icon" />}
                  </Button>
                  <Button className="mi_button_icon" onClick={this.addMemberDefaultHandler}> <i className="fa fa-plus mi_icon" /></Button>
                </Col>
              </Row>
              {this.state.memberfamily
                ? this.state.memberfamily.map((item) => {
                  return (
                    <div>
                      <p className='mi_address_card'>{item.Id}</p>
                      <EditMember item={item} removeMember={this.removeMember} submitHandler={this.addMemberSubmitHandler} ></EditMember>
                    </div>);
                }) : ''}
            </div>
          );
        }
        else {
          familyCard = (
            <div className="mi_main">
              <Row span={24}>
                <Col span={15}>
                  <p className='mi_title' style={{ color: '#fd828d' }}>Family</p>
                </Col>
                <Col span={9}>
                  <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "member")}   > {this.state.memberEditable ?
                    <i className="fa fa-times mi_icon mi_icon_red" />
                    :
                    <i className="fa fa-pencil mi_icon" />}
                  </Button>
                  <Button className="mi_button_icon" onClick={this.addMemberDefaultHandler}> <i className="fa fa-plus mi_icon" /></Button>
                </Col>
              </Row>
              <UserMember member={this.state.memberfamily} />
            </div>
          );
        }
        return (
          <div>
            <Row span={24}>
              <Col md={24} sm={24}>{personalDetailsCard}</Col>
            </Row>
            <Row span={24}>
              <Col md={24} sm={24}>{addressDetailsCard}</Col>
            </Row>
            {/* <div className="mi_main">
              <p className='mi_title' style={{ color: '#fd828d' }}>Address</p>
              <Row span={24}>
                <Col md={4} sm={24}>
                  <p className="mi_name">Street</p>
                  <p className="mi_value">{this.state.memberaddress.street ? this.state.memberaddress.street : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">Street 1</p>
                  <p className="mi_value">{this.state.memberaddress.street1 ? this.state.memberaddress.street1 : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">City</p>
                  <p className="mi_value">{this.state.memberaddress.city ? this.state.memberaddress.city : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">State</p>
                  <p className="mi_value">{this.state.memberaddress.state ? this.state.memberaddress.state : 'none'}</p>
                </Col>
                <Col md={5} sm={24}>
                  <p className="mi_name">Zip Code</p>
                  <p className="mi_value">{this.state.memberaddress.zipCode ? this.state.memberaddress.zipCode : 'none'}</p>
                </Col>
              </Row>
            </div> */}
            <Row span={24}>
              <Col md={24} sm={24}>{familyCard}</Col>
            </Row>
          </div>
        );
      }
      default:
        break;
    }
  }
  render() {
    return (
      <Content>
        {this.state.addMemberActive ? (
          <Modal
            visible={this.state.addMemberActive}
          >
            <AddMember
              closeDrawerHandler={this.addMemberDefaultHandler}
              submitHandler={this.addMemberSubmitHandler}
              width={500}
              // member_types={this.state.member_types}
              userPermandMasters={this.props.userPermandMasters}
              title="Add Family Member"
            />
          </Modal>
        ) : null}
        <div className="mi_main_div">
          {this.getSelectedTabView()}
        </div>
      </Content>
    );
  }
}
export default MemberProfile;
